export default function mediaSlider() {
    return {
        swiper: null,
        videoUrls: [],
        currentVideoIndex: 0,
        initSwiper() {
            if (typeof window.Swiper === 'undefined') {
                console.error('Swiper is not loaded');
                return;
            }

            this.swiper = new window.Swiper(this.$refs.swiperContainer, {
                modules: [window.SwiperNavigation],
                lazy: true,
                lazyPreloadPrevNext: 1,
                navigation: {
                    nextEl: '.swiper-next-button',
                    prevEl: '.swiper-prev-button',
                },

                rewind: true,
                effect: 'slide',
                speed: 500,
                on: {
                    slideChange: () => {
                        // If the audio player is loaded, make sure it stops playing if we navigate away from the audio slide
                        window.audioPlayer ? window.audioPlayer.pause() : null;
                        this.highlightShortcutLink();
                    },
                },
            });

            this.collectVideoUrls();
            this.highlightShortcutLink();
        },

        checkMissingYouTubeVideo(event, promokit_id, video_id) {
            if (event.target.naturalWidth === 120) {
                fetch(`/ajax/hide_missing_video/${promokit_id}/${video_id}`).catch((error) => console.error('Error reporting missing YouTube video:', error));
            }
        },

        closeVideoModal() {
            // Destroy the video player container
            if (this.$refs.videoPlayerContainer) {
                this.$refs.videoPlayerContainer.innerHTML = '';
            }

            // Close the modal if it exists and is currently open
            if (this.$refs.videoModal && this.$refs.videoModal.open) {
                this.$refs.videoModal.close();
            }
        },

        collectVideoUrls() {
            // Collect all video URLs from this component's slides (scoped to avoid cross-instance pollution)
            this.videoUrls = [];
            const container = this.$refs.swiperContainer;
            if (!container) return;
            const videoSlides = container.querySelectorAll('.swiper-slide[data-video-src]');
            videoSlides.forEach((slide) => {
                const videoSrc = slide.getAttribute('data-video-src');
                if (videoSrc) {
                    this.videoUrls.push(videoSrc);
                }
            });
        },

        goToMedia(type) {
            const attr = `data-${type}-slide`;
            const index = this.swiper.slides.findIndex((slide) => slide.hasAttribute(attr));
            if (index !== -1) {
                this.swiper.slideTo(index);
            }
        },

        highlightShortcutLink() {
            const slide = this.swiper.slides[this.swiper.realIndex];
            const types = ['video', 'audio', 'photo'];
            const activeType = types.find((type) => slide.hasAttribute(`data-${type}-slide`));

            types.forEach((type) => {
                const link = this.$refs[`${type}Shortcut`];
                if (link) link.classList.toggle('bg-fuchsia/20', type === activeType);
            });
        },

        loadCurrentVideo() {
            if (!this.$refs.videoPlayerContainer) {
                return;
            }

            // Load the current video
            this.$refs.videoPlayerContainer.innerHTML = '';

            const videoSrc = this.videoUrls[this.currentVideoIndex];
            if (videoSrc) {
                const videoUrl = new URL(videoSrc);
                videoUrl.searchParams.set('autoplay', '1');

                const iframe = document.createElement('iframe');
                iframe.src = videoUrl.toString();
                iframe.className = 'w-full h-full rounded-xl';
                iframe.frameBorder = '0';
                iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope';
                iframe.allowFullscreen = true;
                this.$refs.videoPlayerContainer.appendChild(iframe);
            }
        },

        nextVideo() {
            // Increment the index and wrap around if needed
            this.currentVideoIndex = (this.currentVideoIndex + 1) % this.videoUrls.length;
            this.loadCurrentVideo();
        },

        openVideoModal(srcUrl) {
            this.currentVideoIndex = this.videoUrls.indexOf(srcUrl);
            if (this.currentVideoIndex === -1) {
                this.currentVideoIndex = 0;
            }

            // Set the video source, open the modal, and start playback
            this.loadCurrentVideo();

            this.$refs.videoModal.showModal();
        },

        prevVideo() {
            // Decrement the index and wrap around if needed
            this.currentVideoIndex = (this.currentVideoIndex - 1 + this.videoUrls.length) % this.videoUrls.length;
            this.loadCurrentVideo();
        },
    };
}

// Wait until Alpine is initialized before registering the component
document.addEventListener('alpine:init', () => {
    Alpine.data('mediaSlider', mediaSlider);
});
